import { render, staticRenderFns } from "./ChatRegularFileMessage.vue?vue&type=template&id=8f2abe2c&scoped=true&lang=pug&"
import script from "./ChatRegularFileMessage.vue?vue&type=script&lang=js&"
export * from "./ChatRegularFileMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChatRegularFileMessage.vue?vue&type=style&index=0&id=8f2abe2c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2abe2c",
  null
  
)

export default component.exports